import { FC, PropsWithChildren } from "react";

export const SpinningBlock: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div id="spinner">
      <div className="animate-spin">{children}</div>
    </div>
  );
};
